import { api } from "@api/api";
import { Activity } from "@modules/activities/types";
import { ActivityFormValues } from "@modules/activities/validations";

export async function createActivityService(data: ActivityFormValues): Promise<Activity> {
  const { image, ...body } = data;

  const { data: activity } = await api.post<Activity>("v1/activity_admin/", body);

  if (image && image instanceof File) {
    const formData = new FormData();
    formData.append("image", image);

    await api.patch(`v1/activity_admin/${activity.id}/`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  }

  return activity;
}
